// extracted by mini-css-extract-plugin
export default {"box":"Commissions_box__aWYL8","label":"Commissions_label__xHFC8"};